import { isEmpty } from 'lodash';
import { IPetAlertModel, PetAlertModel } from '.';
import { PetAlerts } from '@common/models/Enums';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';

export interface IPetAlertPetModel extends ISyncModel {
  petAlertPetId: number;
  petAlertId: number | PetAlerts;
  petId: number;
  petAlert?: IPetAlertModel;
}

export class PetAlertPetModel extends SyncModel implements IPetAlertPetModel {
  petAlertPetId: number;
  petAlertId: number | PetAlerts;
  petId: number;
  petAlert?: IPetAlertModel | undefined;

  constructor(params: Partial<PetAlertPetModel> = {}) {
    super(params);
    const {
      petAlertPetId = 0,
      petAlertId = 0,
      petId = 0,
      petAlert = undefined,
    } = params;

    this.petAlertPetId = petAlertPetId;
    this.petAlertId = petAlertId;
    this.petId = petId;
    this.petAlert = !isEmpty(petAlert) ? new PetAlertModel(petAlert) : petAlert;
  }
}
